namespace TabAurous.OMS {
    export interface VoucherTaxDetailsForm {
        VoucherTypeId: Serenity.IntegerEditor;
        TaxId: Serenity.IntegerEditor;
        TaxRate: Serenity.DecimalEditor;
    }

    export class VoucherTaxDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.VoucherTaxDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!VoucherTaxDetailsForm.init)  {
                VoucherTaxDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DecimalEditor;

                Q.initFormType(VoucherTaxDetailsForm, [
                    'VoucherTypeId', w0,
                    'TaxId', w0,
                    'TaxRate', w1
                ]);
            }
        }
    }
}
